var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bonita__form"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('h2',[_vm._v(_vm._s(_vm.subtitle))]),_c('section',{domProps:{"innerHTML":_vm._s(_vm.$t('close', { mail: _vm.mail }))}})])}
var staticRenderFns = []

export { render, staticRenderFns }